import React from 'react';
import {useTheme} from '@mui/material/styles';

import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import useMediaQuery from '@mui/material/useMediaQuery';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ResponsiveDialog({children, ...props}) {
    const {maxWidth = 'md', ...rest} = props;
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down(maxWidth));

    return (
        <Dialog
            fullScreen={isSmall}
            maxWidth={maxWidth}
            fullWidth
            TransitionComponent={Transition}
            {...rest}
        >
            {children}
        </Dialog>
    );
}
